import { RefObject, useEffect } from 'react';
import { message } from 'antd';
import { useTranslation } from 'react-i18next';
import Clipboard from 'clipboard';

const useCopy = (ref: RefObject<HTMLElement> | null) => {
  const { t } = useTranslation();
  useEffect(() => {
    let clip: any = null;
    if (ref && ref.current) {
      clip = new Clipboard(ref.current);
      clip.on('success', (e: any) => {
        e.clearSelection();
        message.success(t('copy_success'));
      });
      clip.on('error', (err: any) => {
        err.clearSelection();
        message.error('复制失败');
      });
    }
    return () => {
      if (clip) {
        clip.off('error');
        clip.off('success');
        clip.destroy();
      }
    };
  }, [ref, t]);
};

export default useCopy;
